import * as React from 'react'
import Socket from '../../../Socket/socket-init'
import * as Utils from '../../../Logic/Utils'
// import { Logic } from '../../../Logic/Type'
import { Main } from '../../../Logic/Main'
// import * as Bet from './Bet'
// import * as RouteClasses from '../../../Socket/route-classes'
import { Link, Redirect } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import { Logic } from '../../../Logic/Type'
// import FacebookProvider, { Like } from 'react-facebook'
import * as Body from './Body'
import * as Assets from '../../../assets/Assets'
import { getTeamShirt } from './Standings'
import * as moment from 'moment'
import Loader from './Loader'
import {Helmet} from 'react-helmet'

const openedGWs: number[] = [27, 28, 29, 30, 31, 32, 33]

interface IState {
  userDropdown: boolean
  listen: boolean
  showConfirmButton: false
  mobileMenu: boolean
  showTable: boolean[]
  popupTeam: boolean
  popupPlayer: boolean
}

export function setPosition(position: string): string {
  switch (position) {
      case 'G':
          return 'Goalkeeper'
      case 'D':
          return 'Defender'
      case 'M':
          return 'Midfielder'
      default:
          return 'Attacker'
  }
}

class Lounge extends React.Component<{history: any}, IState> {  
  
  public cookies

  constructor(props) {
    super(props)

    window.scroll(0, 0)

    this.props.history.push('/lounge')

    this.cookies = new Cookies()

    this.state = {
      userDropdown: false,
      listen: false,
      showConfirmButton: null,
      mobileMenu: false,
      showTable: [false, false, false, false, false, false, false, false],
      popupTeam: false,
      popupPlayer: false
    }

    Logic.Type.New(Main.Instance.Fantasy, {
      chosenResults: undefined,
      selectedResult: ['-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-'],
      selectedAcc: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    })

    localStorage.clear()

    Socket.Send('rounds', {playerId: +this.cookies.get('playerId')})
    Socket.Send('user-leagues', {playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab')})

    Socket.Send('get-leaderboard', {leagueId: 1204})
    Socket.Send('upcoming-fixtures', {competition: 'premier-league'}) 
  }

  componentWillReceiveProps() {
    if (this.state.listen === true) {
      const matches = Socket.Get<any>('matches')
      const results = Socket.Get<any>('results')
      if (matches.loading === 'loaded' && results.loading === 'loaded') {
        Utils.fillChosenResults(matches, results)
        this.setState({ listen: false })
      }
    }
  }

  componentDidUpdate() {
    const rounds = Socket.Get<any>('rounds')
    if (rounds.loading === 'loaded') {
      const currentTime = moment().local()
      let closestRound: any = rounds.rounds[0]
      for (const item of rounds.rounds) {
        const utcDeadline = moment.utc(item.deadline, 'llll')
        const deadline = moment(utcDeadline).local()
        const difference: number = currentTime.valueOf() - deadline.valueOf()
        if (+difference < 0) {
          closestRound = item
          break
        }
      }
      const roundsTable = document.getElementById('rounds-table') as HTMLElement
      const firstRound = document.getElementById('round-1') as HTMLElement
      if (roundsTable && firstRound) {
        roundsTable.scrollTop = firstRound.offsetHeight * (closestRound.roundId - 2)
      }
    }
  }

  render() {
    if (Main.Instance.Fantasy.chosenResults !== undefined) {
      return <Redirect to={{pathname:'/confirmation', state: { showConfirmButton: false } }}/>
    }
    const rounds = Socket.Get<any>('rounds')
    const userLeagues = Socket.Get<any>('user-leagues')
    const upcomingFixtures = Socket.Get<any>('upcoming-fixtures')
    const standings = Socket.Get<any>('get-leaderboard')
    if (rounds.loading !== 'loaded' || userLeagues.loading !== 'loaded' || upcomingFixtures.loading !== 'loaded' || standings.loading !== 'loaded') {
      return <Loader/>
    } else {
      return (
          <section className="wrapper"> 
            <Helmet>
              <meta charSet="utf-8"/>
              <title>The Accumulator Club – Premier League predictions - Lounge</title>
              <meta 
                  name="description" 
                  content="Play our awesome free to play predictor game at The Accumulator Club and you can win
                  cash. Make your predictions on a number of different betting markets and earn points based on real
                  sportsbook odds. Visit the lounge, make your Premier League predictions and follow the action."
              />
            </Helmet>
            <div className="header" role="banner">
                <header className="navbar navbar-default">
                    <div className="container" style={{ marginBottom: '0' }}>
                        <div className="navbar-header">
                          <button 
                            onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                            type="button" 
                            className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                            data-toggle="collapse" 
                            data-target="#navbar-collapse-mid" 
                            aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                          >
                            <span className="sr-only">Toggle navigation</span>
                            <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                            <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                            <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                          </button>                                  
                          <Link className="navbar-brand" to="/">
                            <img src="logo-main2.png" alt="" className="logo" />
                          </Link> 
                          <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                        </div>
                        <nav 
                          className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                          id="navbar-collapse-left"
                          aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                          style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                        >
                          {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                        </nav>
                        <nav className="collapse navbar-collapse" id="user-profile">
                            <ul className="nav navbar-nav navbar-right">
                                <li className="user-nav-option">
                                    <div className="user">
                                        <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                            <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                              <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                {(this.cookies.get('username')) ? 
                                <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                    <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                      <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                    </a>
                                    <ul className="dropdown-menu">
                                          <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                          <li onClick={() => Utils.logout()}>
                                            <Link to="/login">
                                              <i className="icon-logout"/>
                                              LOGOUT
                                            </Link>
                                          </li>
                                    </ul>
                                </li>
                                :
                                null}
                            </ul>
                        </nav>
                    </div>
                </header>
            </div>
            <main className="main">
              <div className="container">
                <div className="section-left">
                  <ul className="nav nav-tabs nav-justified nav-lg" role="tablist">
                    <li role="presentation" className="active">
                      <a
                        aria-controls="join"
                        role="tab"
                        data-toggle="tab"
                      >
                        PREMIER LEAGUE 2018/19
                      </a>
                    </li>
                    {/*
                    <li role="presentation" className={(+this.cookies.get('competitionTab') === 2) ? 'active' : null}>
                      <a 
                        href="javascript:void(0)" 
                        onClick={() => {this.cookies.set('competitionTab', 2),
                                        Socket.Send('upcoming-fixtures', {competition: 'european'}), 
                                        Socket.Send('user-leagues', {playerId: +this.cookies.get('playerId'), tab: 2})}}
                        aria-controls="join"
                        role="tab"
                        data-toggle="tab"
                      >EUROPEAN
                      </a>
                    </li>
                    <li role="presentation" className={(+this.cookies.get('competitionTab') === 3) ? 'active' : null}>
                      <a 
                        href="javascript:void(0)" 
                        onClick={() => {this.cookies.set('competitionTab', 3),
                                        Socket.Send('upcoming-fixtures', {competition: 'la-liga'}), 
                                        Socket.Send('user-leagues', {playerId: +this.cookies.get('playerId'), tab: 3})}} 
                        aria-controls="join" 
                        role="tab" 
                        data-toggle="tab"
                      >LA LIGA
                      </a>
                    </li>
                    <li role="presentation" className={(+this.cookies.get('competitionTab') === 4) ? 'active' : null}>
                      <a 
                        href="javascript:void(0)" 
                        onClick={() => {this.cookies.set('competitionTab', 4),
                                        Socket.Send('get-leaderboard', {league: 'england'})
                                        Socket.Send('upcoming-fixtures', {competition: 'premier-league'}), 
                                        Socket.Send('user-leagues', {playerId: +this.cookies.get('playerId'), tab: 4})}} 
                        aria-controls="join" 
                        role="tab" 
                        data-toggle="tab"
                      >PREMIER LEAGUE
                      </a>
                    </li>
                    */}
                  </ul>
                  <div className="compition-table">
                    <div className="tab-content custom">
                    <div role="tabpanel" className="tab-pane active" id="euro-2016">
                    <div className="lounge-rounds">
                      <div>
                        <span>COMPETITION</span>
                        <span>DEADLINE</span>
                        <span>PRIZE</span>
                        <span/>
                      </div>
                      <div className="rounds-table" id="rounds-table">
                        {this.setRounds()}
                      </div>
                    </div>
                    </div>
                    </div>
                  </div>
                  <div className="league-rank">
                    <span className="section-heading">STANDINGS</span>
                    <div className="standings-groups">
                      <table>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th style={{ width: '40%' }}>Team</th>
                              <th>Games Played</th>
                              <th className="mobile-hide">Goals For</th>
                              <th className="mobile-hide">Goals Against</th>
                              <th className="mobile-hide">Goal Difference</th>
                              <th style={{ borderRight: '0' }}>Points</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.setStandings()}
                          </tbody>
                        </table>
                    </div>
                  </div>
                </div>
                <div className="section-right">
                  <div className="league-rank">
                    <div className="section-heading">SOCIAL CHANNELS</div>
                    <div className="section-content">
                      <span className="social-span" style={{ marginTop: '10px' }}>
                        <iframe 
                          src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Faccumulatorclub%2F&width=88&layout=button_count&action=like&size=large&show_faces=false&share=false&height=21&appId" 
                          width="150" 
                          height="30" 
                          style={{ border:'none', overflow:'hidden'}}
                          scrolling="no"
                        />
                      </span>
                      <span className="social-span" style={{ background: '#1b95e0', marginBottom: '10px' }}>
                        <a href="https://twitter.com/TheAccaClub?ref_src=twsrc%5Etfw" target="_blank" data-show-count="false">Follow @TheAccaClub</a>
                        <script async={true} src="https://platform.twitter.com/widgets.js"/>
                      </span>
                    </div>
                  </div>
                    {(this.cookies.get('playerId')) ?
                    <div className="league-rank">
                      <div className="section-heading">MY LEAGUES</div>
                      <div className="section-content">
                        <div className="row">
                          <ul className="list-unstyled">
                            <li style={{ background: 'rgb(231, 231, 231)' }}>
                              <div className="league">
                                <span className="bold">Private leagues</span>
                                <span>{''}</span>
                              </div>
                            </li>
                            {this.setLeagues()}
                          </ul>
                        </div>
                        <div className="row" style={{ background: 'rgb(231, 231, 231)' }}>
                          <ul className="list-unstyled">
                            <li>
                              <Link 
                                onClick={() => {Socket.Send('leaderboards', {playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab')}), localStorage.setItem('overallRanking', 'true')}}
                                to="/leaderboards"
                              >
                                <div className="league">
                                  <span className="bold">Overall ranking</span>
                                  <span>{''}</span>
                                </div>
                                <div className="league-ranking">
                                  <span className="badge badge-warning bagde-rank">{userLeagues.userLeagues[0].playerPosition.toString()}</span>
                                </div>
                              </Link>
                            </li>
                          </ul>
                        </div>
                    </div>
                  </div>
                  : null}
                </div>
                <div>{this.upcomingFixturesSection(upcomingFixtures)}</div>
              </div>
              {(this.state.popupTeam) ? this.showPopupTeam() : null}
              {(this.state.popupPlayer) ? this.showPopupPlayer() : null}
            </main>
          </section>
      )
    }
  }

  upcomingFixturesSection(upcomingFixtures: any): JSX.Element {
    return (
      <div className="section-right">
        <div className="league-rank">
          <div className="section-heading">UPCOMING FIXTURES</div>
          <div className="section-content">
            <div className="row">
              {this.setUpcomingFixtures(upcomingFixtures.upcomingFixtures)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  setStandings(): JSX.Element[] {
    const rows: JSX.Element[] = []
    const leaderboard: any = Socket.Get<any>('get-leaderboard').leaderboard
    for (let i = 0; i < leaderboard.length; i++) {
      rows.push(
        <tr key={rows.length} style={{ background: (i % 2 === 0) ? 'rgb(241, 241, 241)' : 'rgb(255, 255, 255)' }}>
          <td style={{ fontWeight: 'bold' }}>{leaderboard[i].position}</td>
          <td 
            style={{ color: 'rgb(41, 160, 0)', fontWeight: 'bold', cursor: 'pointer' }} 
            onClick={() => {Socket.Send('get-team-info', {teamId: +leaderboard[i].id}), this.setState({ popupTeam: true })}}
          >
          {leaderboard[i].name}
          </td>
          <td>{leaderboard[i].gamesPlayed}</td>
          <td className="mobile-hide">{leaderboard[i].goalsFor}</td>
          <td className="mobile-hide">{leaderboard[i].goalsAgainst}</td>
          <td className="mobile-hide">{leaderboard[i].goalsDifference}</td>
          <td>{leaderboard[i].points}</td>
        </tr>
      )
    }

    return rows
  }

  setRounds(): JSX.Element[] {
    const playerId = this.cookies.get('playerId')
    const currentTime = moment().local()
    let roundsReturn: JSX.Element[] = []
    const rounds = Socket.Get<any>('rounds').rounds
    for (let i = 0; i < rounds.length; i++) {
      const utcDeadline = moment.utc(rounds[i].deadline, 'llll')
      const deadline = moment(utcDeadline).local()
      roundsReturn.push (
        <div key = {roundsReturn.length} id = {'round-' + (i + 1)}>
          <span><b>{rounds[i].roundName}</b></span>
          <span>{deadline.format('llll')}</span>
          <span>{rounds[i].prizes}</span>
          <span style={{ textAlign: 'right' }}>
            {(rounds[i].played) ? 
                (currentTime > deadline) ?
                    <Link 
                        to={{ pathname:'/results', state: { playerId: +this.cookies.get('playerId'), resultsRound: rounds[i].roundId, showConfirmButton: false } }} 
                        className="btn btn-primary" 
                        onClick={() => {localStorage.setItem('roundId', rounds[i].roundId.toString()), Socket.Send('results', {playerId: +this.cookies.get('playerId'), round: rounds[i].roundId})}}
                    >
                        VIEW
                    </Link>
                : 
                    <a 
                        className="btn btn-primary" 
                        onClick={() => {localStorage.setItem('roundId', rounds[i].roundId.toString()),
                                    Socket.Send('results', {playerId: +this.cookies.get('playerId'), round: rounds[i].roundId}),
                                    Socket.Send('matches', {round: rounds[i].roundId}),
                                    this.setState({ listen: true, showConfirmButton: false })}}
                    >
                        VIEW
                    </a>
            : 
                (currentTime <= deadline || (openedGWs.includes(+rounds[i].roundId) && +playerId === 61) || +playerId >= 232) ?
                    <Link
                        to={{ pathname:'/betstep1', state: { showConfirmButton: true } }}
                        className="btn btn-primary" 
                        onClick={() => {localStorage.setItem('roundId', rounds[i].roundId.toString()), Socket.Send('matches', {round: rounds[i].roundId})}}
                    >
                        JOIN
                    </Link>
                :
                    <a 
                        className="btn btn-primary"
                        onClick={() => alert('Deadline for this round has passed.')}
                    >
                        JOIN
                    </a>
            }
          </span>
        </div>
      )
    } 

    return roundsReturn
  }

  setLeagues(): JSX.Element[] {
    const leaguesReturn: JSX.Element[] = []
    const userLeagues = Socket.Get<any>('user-leagues').userLeagues
    if (userLeagues.length < 2) {
      leaguesReturn.push(
        <li key={leaguesReturn.length}>
          <Link 
            to={(!this.cookies.get('playerId')) ? '/login' : '/leagues'}   
          >
            <div className="league">
              <span className="bold">No private league created yet!</span>
            </div>
          </Link>
        </li>
      )
    }
    for (let i = 1; i < userLeagues.length; i++) {
      leaguesReturn.push(
        <li key={leaguesReturn.length}>
          <Link 
            to="/leaderboards"
            onClick={() => {Socket.Send('leaderboards', {playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab'), league: userLeagues[i].leagueId}), 
                            localStorage.setItem('leaderboardLeagueName', userLeagues[i].leagueName),
                            localStorage.setItem('leagueId', userLeagues[i].leagueId),
                            localStorage.setItem('leagueCode', userLeagues[i].leagueCode),
                            localStorage.setItem('overallRanking', 'false')}}    
          >
            <div className="league">
              <span className="bold">{userLeagues[i].leagueName}</span>
              <span>By {userLeagues[i].leagueAdmin}</span>
            </div>
            <div className="league-ranking">
              <span className="badge badge-warning bagde-rank">{userLeagues[i].playerPosition.toString()}</span>
            </div>
          </Link>
        </li>
      )
    }
  
    return leaguesReturn
  }

  showPopupTeam(): JSX.Element {
    const team = Socket.Get<any>('get-team-info')
    if (team.loading !== 'loaded') {
        return <Loader/>
    } else {
        const screenPosition = document.scrollingElement.scrollTop + 100
        const top = screenPosition.toString() + 'px'
        const selectedTeam = team.teamInfo
        return (
            <div className="popup">
                <div id="popup-below" className="popup-inner" style={{ top, maxHeight: '600px', overflow: 'scroll' }}>
                    <div className="team-info" style={{ marginBottom: '20px' }}>
                        <div style={{ position: 'relative', marginBottom: '20px' }}>
                            <span style={{ marginRight: '20px' }}><img src={'data:image/png;base64,' + selectedTeam.logo} style={{ width: '70px', height: '60px' }} /></span>
                            <span className="team-info-name">{selectedTeam.name.toUpperCase()}</span>
                            <span className="team-info-close"><img src="cancel.svg" style={{ width: '30px', height: '30px' }} onClick={() => this.setState({ popupTeam: false })} /></span>
                        </div>
                        <div className="team-data" style={{ textAlign: 'left' }}>
                            <span>Coach: <p>{selectedTeam.coach}</p></span>
                        </div>
                    </div>
                    <div className="team-players">
                        <p style={{ fontSize: '16px' }}><b>TEAM SQUAD</b></p>
                        <div className="team-table">
                            {this.setSquad(selectedTeam)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
  }

  setSquad(team: any): JSX.Element[] {
    const players: JSX.Element[] = []
    const teamShirt = getTeamShirt(team.name)
    for (let i = 0; i < team.squad.length; i++) {
        const injured = team.sidelined.find((elt) => +elt.id === +team.squad[i].id)
        if (i === 0 || (team.squad[i - 1] && team.squad[i - 1].position !== team.squad[i].position)) {
          players.push(
              <p key={players.length} style={{ fontSize: '15px', marginBottom: '0' }}><b>{setPosition(team.squad[i].position) + 's'}</b></p>
          )
        }
        players.push(
            <div key={players.length} className="team-table-player">
                <div className="team-table-player-shirt">
                    <img src={teamShirt.src}/>
                    <div 
                        className={(team.squad[i].number.toString().length === 1) ? 'text-on-image shirt-one-number' : 'text-on-image shirt-two-numbers'}
                        style={{ color: teamShirt.color, textShadow: teamShirt.textShadow }}
                    >
                    {team.squad[i].number}
                    </div>
                </div>
                <div style={{ width: '65%', marginLeft: '5%' }}>
                    <span 
                        onClick={() => {
                            this.setState({ popupPlayer: true }),
                            Socket.Send('get-player-info', {playerId: team.squad[i].id})  
                        }}
                    >
                    <a style={{ color: (injured) ? '#F03300' : 'rgb(41, 160, 0)'}}>{team.squad[i].name}</a>
                    </span>
                    <span>{'Age: ' + team.squad[i].age}</span>
                    <span>{'Appearances: ' + team.squad[i].appearences}</span>
                </div>
            </div>
        )
    }
    return players
  }

  showPopupPlayer() {
    const team = Socket.Get<any>('get-team-info')
    const chosenPlayer = Socket.Get<any>('get-player-info')
    if (team.loading === 'loaded' && chosenPlayer.loading === 'loaded') {
        const playerProfile = chosenPlayer.playerInfo
        const selectedTeam = team.teamInfo
        const screenPosition = document.scrollingElement.scrollTop + 100
        document.getElementById('popup-below').style.zIndex = '0'
        const top = screenPosition.toString() + 'px'
        const injured = selectedTeam.sidelined.find((elt) => +elt.id === +playerProfile.playerId)
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="team-players">
                        <div style={{ marginBottom: '20px', position: 'relative' }}>
                            <span style={{ marginRight: '20px' }}>
                                <img src={'data:image/png;base64,' + playerProfile.image} className="player-profile-picture"/>
                            </span>
                            <span className="team-info-name team-info-player-name">{playerProfile.name.toUpperCase()}</span>
                            <span className="team-info-close"><img src="cancel.svg" style={{ width: '30px', height: '30px' }} onClick={() => this.setState({ popupPlayer: false })}/></span>
                        </div>
                        <h3>Profile</h3>
                        <table className="team-table">
                            <thead>
                                <tr>
                                    <th>Team</th>
                                    <th>Position</th>
                                    <th className="player-stats-hide">Age</th>
                                    <th>Club</th>
                                    <th className="player-stats-hide">Height</th>
                                    <th className="player-stats-hide">Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><img src={'data:image/png;base64,' + selectedTeam.logo} className="player-team-logo"/></td>
                                    <td>{playerProfile.position}</td>
                                    <td className="player-stats-hide">{playerProfile.age}</td>
                                    <td>{playerProfile.club}</td>
                                    <td className="player-stats-hide">{playerProfile.height}</td>
                                    <td className="player-stats-hide">{playerProfile.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                        {(injured) ?
                        <div>
                            <span style={{ marginTop: '20px', fontSize: '20px', color: '#F03300'}}><b>Injury stats</b></span>
                            <div className="injury-stats">
                                <span><b>Injury: </b><i>{injured.description}</i></span>
                                <span><b>Injured from: </b><i>{injured.startDate}</i></span>
                                <span><b>Expected comeback: </b><i>{(injured.endDate !== '') ? injured.endDate : 'Unknown'}</i></span>
                            </div>
                        </div>
                        : null}
                        <div>
                            {(playerProfile.thisSeasonStats) ? this.setPlayerStats(playerProfile.thisSeasonStats) : null}
                            {(playerProfile.lastSeasonStats) ? this.setPlayerStats(playerProfile.lastSeasonStats) : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
  }

  checkInjury(player: string, sidelined: any) {
    for (const item of sidelined) {
        if (item.name === player) return item
    }
  }

  setPlayerStats(stats: any) {
    return (
        <div className="previous-seasons">
            <span><b>{stats.competition + ' ' + stats.season}</b></span>
            <table className="team-table">
                <thead>
                    <tr>
                        <th>Appearances</th>
                        <th>Starts</th>
                        <th>Minutes</th>
                        <th className="player-stats-hide">Substitutes In</th>
                        <th className="player-stats-hide">Substitutes Out</th>
                        <th>Goals</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{stats.appearances}</td>
                        <td>{stats.starts}</td>
                        <td>{stats.minutes}</td>
                        <td className="player-stats-hide">{stats.substitutesin}</td>
                        <td className="player-stats-hide">{stats.substitutesout}</td>
                        <td>{stats.goals}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
  }

  setUpcomingFixtures(fixtures: any): JSX.Element[] {
    const fixturesReturn: JSX.Element[] = []
    if (fixtures) {
      for (let i = 0; i < fixtures.length; i++) {
        const utcTime = moment.utc(fixtures[i].time, 'LT')
        const time = moment(utcTime).local()
        if (i === 0 || fixtures[i].date !== fixtures[i - 1].date) {
          fixturesReturn.push(
            <div key={fixturesReturn.length} className="wedg-date">{fixtures[i].date}</div>
          )
        }
        fixturesReturn.push(
          <div key={fixturesReturn.length} className="match-desc">
            <span>{fixtures[i].homeTeam}</span>
            <span className="two">{fixtures[i].awayTeam}</span>
            <label>{time.format('LT')}</label>
          </div>
        )
      }
    }
  
    return fixturesReturn
  }
  
}


export default withCookies(Lounge)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Lounge.tsx